export default __webpack_public_path__ + "static/media/Untitled-Artwork.1e7b070a.jpg";